import { checkRecordingInProgress } from 'util/recording';
import isNil from 'lodash/isNil';
import { recordingStore } from 'state/store';
import { selectDeltaWithServerTime } from './room';
import { selectUserId } from './auth';

export const selectRecordingStatus = () => {
    return recordingStore.status;
};

export const selectRecordingData = () => {
    return recordingStore.data;
};

export const selectIsRecording = () => {
    const recordingData = selectRecordingData();
    const isRecording = !isNil(recordingData) && checkRecordingInProgress(recordingData);

    return isRecording;
};

export const selectRecordingInitiatorData = () => {
    const isRecording = selectIsRecording();

    if (isRecording) {
        const recordingData = selectRecordingData();
        return recordingData;
    }

    return null;
};

export const selectRecordingDuration = () => {
    const deltaWithServerTime = selectDeltaWithServerTime();
    const recordingData = selectRecordingInitiatorData();

    if (recordingData && checkRecordingInProgress(recordingData)) {
        const { serverInitTime } = recordingData;
        const durationInMs = Date.now() - (serverInitTime + deltaWithServerTime);
        const duration = durationInMs <= 0 ? 0 : Math.floor(durationInMs / 1000); // ms в s
        return duration;
    }

    return 0;
};

export const selectIsMeRecordingInitiator = () => {
    const recordingInitiator = selectRecordingInitiatorData();
    const recordingInitiatorId = recordingInitiator?.initiatorId;
    const myId = selectUserId();

    if (!recordingInitiatorId || !myId) return false;

    return recordingInitiatorId === myId;
};
